module.exports = __webpack_public_path__ + "img/strat_shad2.58919c62.png";